import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTheme, Container, Icon, Typography } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import GroupIcon from "@material-ui/icons/Group";
import Header from "../components/layout/Header/Header";
import Pane from "../components/layout/Pane/Pane";
import Tabs from "../components/layout/Pane/Tabs";

import { UserContext } from "../contexts/UserContext";
import Footer from "../components/layout/Footer";
import { PaneContext } from "../contexts/PaneContext";
import { Users } from "../components/Admin/Users";
import { Sites } from "../components/Admin/Sites";
import { SubHeading } from "../components/ui/SubHeading";

const Admin = () => {
  const { id, userRole } = useContext(UserContext);
  const { changeTab } = useContext(PaneContext);
  const navigate = useNavigate();

  const { palette } = useTheme();

  useEffect(() => {
    changeTab(0);
    //eslint-disable-next-line
  }, []);

  if (!id) return navigate("/", { replace: true });
  else if (userRole === "admin") {
    return (
      <PageContainer>
        <Header />
        <Container>
          <AdminPane
            variant="admin"
            colour={palette.error.main}
            subHeader={
              <Typography style={Tstyles}>
                <PersonIcon style={iconStyles1} /> Admin Panel
              </Typography>
            }
          >
            <Tabs
              colour="error"
              data={[
                {
                  index: 0,
                  title: (
                    <Typography style={Tstyles}>
                      {" "}
                      <AccountBalanceIcon style={iconStyles} /> Sites
                    </Typography>
                  ),
                  //icon: AccountBalanceIcon,
                  component: <Sites />,
                },
                {
                  index: 1,
                  title: (
                    <Typography style={Tstyles}>
                      {" "}
                      <GroupIcon style={iconStyles} /> Users
                    </Typography>
                  ),
                  //icon: GroupIcon,
                  component: <Users />,
                },
              ]}
            />
          </AdminPane>
        </Container>
        <Footer />
      </PageContainer>
    );
  } else return navigate("/", { replace: true });
};

const iconStyles = {
  fontSize: "18px",
};

const iconStyles1 = {
  fontSize: "16px",
};

const Tstyles = {
  fontWeight: "Bold",
  fontSize: "16px",
};

const PageContainer = styled.main`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AdminPane = styled(Pane)`
  margin-top: 4rem;
`;

export default Admin;
